import styled from 'styled-components';
import { defaultColors } from '@components/themes';
import { TextPairing } from '@components/TextPairing';
import { Box } from '@components/Box';
import { Text } from '@components/typography';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { defaultBase64Placeholder } from '@components/CloudImage';

export const BubbleWrapper = styled(Box)`
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 48.59%, rgba(255, 255, 255, 0.48) 100%);
  border: 2px solid #ffffff;
  box-sizing: border-box;
  backdrop-filter: blur(16px);
  align-self: center;
  border-radius: 96px;
  position: relative;
  ${themeMediaQuery('below_sm')} {
    width: 90%;
    padding: ${themeSpace(10)} ${themeSpace(8)} ${themeSpace(10)} ${themeSpace(8)};
    border-radius: 70px;
  }
`;

export const Number = styled.div`
  background-color: ${defaultColors.red4};
  padding: ${themeSpace(9)};
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 175px;
  height: 175px;
  position: absolute;
  right: -5%;
  top: -7%;
  ${themeMediaQuery('below_sm')} {
    width: 79px;
    height: 79px;
    padding: ${themeSpace(4)};
    right: -15px;
    top: -22px;
    text-align: center;
  }
`;

export const NumberUpdate = styled(Number)`
  opacity: 0;
`;

export const TrackWrapper = styled(Box)<{
  isScrolledIntoView: boolean;
}>`
  background: url(${({ isScrolledIntoView }) =>
    isScrolledIntoView ? cloudAssetUrl('wedding-invitations/rsvp-notifications/notifications_bg1.jpg') : defaultBase64Placeholder});
  background-size: cover;
  background-attachment: fixed;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;

  ${themeMediaQuery('below_sm')} {
    // For explanation of this change on mobile see the following:
    // see: https://stackoverflow.com/questions/23236158/how-to-replicate-background-attachment-fixed-on-ios
    // see: https://stackoverflow.com/questions/20443574/fixed-background-image-with-ios7
    background-size: unset;
    background-attachment: scroll;
    background-position: 50% 100%;
  }
`;

export const NotificationNumberWrapper = styled(Text)`
  font-style: normal;
  font-weight: bold;
  font-size: 115.294px;
  line-height: 156px;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    padding: ${themeSpace(0)};
    font-size: 52px;
  }
`;
export const BubbleTextWrapper = styled(TextPairing)`
  font-style: normal;
  font-weight: bold;
  font-size: 115.294px;
  line-height: 156px;
  .text-pairing-title {
    max-width: 610px;
  }
  .text-pairing-body {
    padding: ${themeSpace(0)} 150px;
  }
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    padding: ${themeSpace(0)};
    font-size: 52px;
    .text-pairing-body {
      padding: ${themeSpace(0)};
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 790px;
    }
  }
`;
